module.exports = __webpack_public_path__ + "static/img/016.9e6a503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/016.png
// module id = Znl6
// module chunks = 1